import axios from 'axios';

const instance = axios.create({
    baseURL: "https://api2.new-age.com.ar/wp-json/wc/v3",
    auth: {
        username: "ck_60dae0d5b4ae51fe6b238552053c17dfc8891bc4",
        password: "cs_6f2530f523c641ecc3dc837654f161d84aa2e074",
    },
});
export default instance;